import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { companyData } from '../data/mock';

const Header = ({ onPartnerClick }) => {
  const [open, setOpen] = useState(false);

  const linkClass = 'font-medium transition-colors text-gray-600 hover:text-[#1a365d]';

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b bg-white/95 border-gray-100 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="header-logo-link">
          <img
            src={companyData.logo}
            alt="Berkshire Investment Group Inc."
            className="w-56 h-auto object-contain"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-6">
          <Link to="/" className={linkClass} data-testid="nav-home">Home</Link>
          <Link to="/strategy/platforms" className={linkClass} data-testid="nav-platforms">Platforms</Link>
          <Link to="/strategy/capital" className={linkClass} data-testid="nav-capital">Capital</Link>
          <Link to="/strategy/roadmap" className={linkClass} data-testid="nav-roadmap">Roadmap</Link>
          <Link to="/leadership" className={linkClass} data-testid="nav-leadership">Leadership</Link>
          <Link to="/africa" className={linkClass} data-testid="nav-africa">Africa</Link>
          <Link to="/institutional" className={linkClass} data-testid="nav-institutional">Institutional</Link>
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={onPartnerClick}
            className="hidden sm:inline-flex bg-[#2f9e8e] hover:bg-[#268578] text-white px-5 py-2.5 rounded-lg font-medium transition-all hover:shadow-lg"
            data-testid="header-partner-btn"
          >
            Capital Partners
          </button>
          <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-gray-700" data-testid="header-mobile-toggle">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t bg-white border-gray-100">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-3">
            <Link to="/" className={linkClass} onClick={() => setOpen(false)}>Home</Link>
            <Link to="/strategy/platforms" className={linkClass} onClick={() => setOpen(false)}>Platforms</Link>
            <Link to="/strategy/capital" className={linkClass} onClick={() => setOpen(false)}>Capital</Link>
            <Link to="/strategy/roadmap" className={linkClass} onClick={() => setOpen(false)}>Roadmap</Link>
            <Link to="/leadership" className={linkClass} onClick={() => setOpen(false)}>Leadership</Link>
            <Link to="/africa" className={linkClass} onClick={() => setOpen(false)}>Africa Special Situations</Link>
            <Link to="/institutional" className={linkClass} onClick={() => setOpen(false)}>Institutional</Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
